<template>
  <div class="spa-location-detail">
    <GMap
      class="spa-location-detail__map"
      :location="spa.location"
    />

    <div
      itemprop="openingHours"
      class="spa-location-detail__schedule"
    >
      <h3 class="spa-location-detail__schedule__header">
        <Lang by-key="spa-schedule" />
      </h3>

      <div
        v-for="(hours, days) in spa.schedule"
        :key="`${spa.uuid}-schedule-${days}-${hours}`"
      >
        <p class="spa-location-detail__schedule__day">
          {{ days }}
        </p>
        <p
          v-for="hour in hours"
          :key="days + hour"
        >
          {{ hour }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import GMap from '~/core/components/shared/GMap.vue'

import type { Spa } from '~/core/ts/entity/Spa'

export default defineNuxtComponent({
  components: {
    GMap,
  },
  props: {
    spa: {
      type: Object as PropType<Spa>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.spa-location-detail {
  @apply py-4;

  &__map {
    @apply px-4;
    height: 267px;
    width: 100%;
    @screen lg {
      height: 377px;
      @apply w-full;
    }
  }

  &__schedule{
    @apply mt-4 mb-4 px-6;
    &__header {
      @apply text-spl-dark;
      font-size: 16px;
      @apply font-bold;
      @apply mt-0 mb-4;
    }

    &__day {
      @apply font-semibold;
      @apply capitalize;
    }
  }

  @screen lg {
    @apply flex flex-row;

    &__schedule{
      min-width: 200px;
      @apply mt-0;
    }
  }
}
</style>
